export default __webpack_public_path__ + "static/media/Band of the Wall Guardian.5a0bbdaa.jpg";